import { render } from "./media_upload.vue?vue&type=template&id=5556a4cf"
import script from "./media_upload.js?vue&type=script&lang=js"
export * from "./media_upload.js?vue&type=script&lang=js"

import "./media_upload.vue?vue&type=style&index=0&id=5556a4cf&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__